// extracted by mini-css-extract-plugin
module.exports = {"toggle":"ToggleTranslation_toggle__4gZQl","switch":"ToggleTranslation_switch__2P40I","slider":"ToggleTranslation_slider__1N_fh"};